import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'

@Injectable()
export class ToasterService {

    constructor(private http: HttpClient) { }

    showErrorToaster(msg) {
        const toaster = document.getElementById('snackbar');
        toaster.innerHTML = msg;
        toaster.className = 'error';
        setTimeout(function () { toaster.className = toaster.className.replace("error", ""); }, 8000);
    }

    showErrorToasterEndo(msg) {
        const toaster = document.getElementById('snackbarEndo');
        toaster.innerHTML = msg;
        toaster.className = 'error';
        setTimeout(function () { toaster.className = toaster.className.replace("error", ""); }, 8000);
    }

    showSuccessToaster(msg) {
        const toaster = document.getElementById('snackbar');
        toaster.innerHTML = msg;
        toaster.className = 'success';
        setTimeout(function () { toaster.className = toaster.className.replace("success", ""); }, 8000);
    }

}
